import { JT } from "./jumbotronTokens";

// Presentational LIVE inset score strip. Additive: renders only when score data exists.
export default function LiveScoreStrip({ scoreText, contextText }) {
  if (!scoreText) return null;
  return (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      background: JT.bg.well, border: `1px solid ${JT.border.inset}`,
      borderRadius: JT.radius.insetRow, padding: "6px 10px", margin: "8px 0",
    }}>
      <span style={{ fontSize: 11, fontWeight: 800, color: JT.text.primary }}>{scoreText}</span>
      {contextText && <span style={{ fontSize: 11, fontWeight: 800, color: JT.status.live.color }}>{contextText}</span>}
    </div>
  );
}
